import { z } from 'zod'

/**
 * System contract of the backend API v1 (OpenAPI: `ProfileOut`, `Profile`).
 *   GET /system/profile → { profile }    no sign-in; served by every deployment profile
 *
 * The backend serves only the endpoints of its own **deployment profile** (`MESAI_PROFILE`):
 * `training` builds models, `plant` serves the shop floor, `all` is one host for both roles and
 * the default. The dashboard reads this endpoint to check that the modules it was configured with
 * are ones that backend serves.
 *
 * The backend answers the profile on `GET /health` as well, but that path is outside the API
 * prefix and the web server of the dashboard forwards only the prefix, so a browser cannot read
 * it. This endpoint is the one for the dashboard.
 */
export const API_PROFILES = ['training', 'plant', 'all'] as const
export const apiProfileSchema = z.enum(API_PROFILES)
export type ApiProfile = z.infer<typeof apiProfileSchema>

export const profileResponseSchema = z.object({ profile: apiProfileSchema })
export type ProfileResponse = z.infer<typeof profileResponseSchema>
